import { Instagram, Facebook, Linkedin, MessageCircle, MapPin, Phone, Mail, Clock } from "lucide-react";
import { BRAND } from "../../lib/constants";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#3D5311] border-t border-white/10 text-white">
      <div className="container-tight py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <img src="/images/brand/vt_logo_darkbg.png" alt="Velarias Tens" className="h-14 w-auto" />
          </div>
          <p className="mt-6 max-w-sm text-white/65 text-sm leading-relaxed">
            Arquitectura textil premium en México. 20 años diseñando, fabricando e instalando
            velarias y tensoestructuras a medida.
          </p>
          <div className="mt-6 flex items-center gap-3">
            {[
              { href: BRAND.social.instagram, Icon: Instagram, label: "Instagram" },
              { href: BRAND.social.facebook, Icon: Facebook, label: "Facebook" },
              { href: `https://wa.me/${BRAND.whatsappNumber}`, Icon: MessageCircle, label: "WhatsApp" },
              { href: BRAND.social.linkedin, Icon: Linkedin, label: "LinkedIn" },
            ].map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 grid place-items-center border border-white/15 hover:border-accent hover:text-accent transition-colors"
                aria-label={s.label}
                data-testid={`footer-social-${s.label.toLowerCase()}`}
              >
                <s.Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-accent">Contacto</p>
          <ul className="mt-5 space-y-3 text-white/75 text-sm">
            <li className="flex items-start gap-3" data-testid="footer-phone-call">
              <Phone className="w-4 h-4 text-accent mt-0.5" />
              <span>
                <span className="block text-[10px] font-mono uppercase tracking-wider text-white/40 leading-none mb-0.5">Llamadas</span>
                <a href={`tel:${BRAND.phoneTel}`} className="hover:text-accent">{BRAND.phoneFullDisplay}</a>
              </span>
            </li>
            <li className="flex items-start gap-3" data-testid="footer-whatsapp">
              <MessageCircle className="w-4 h-4 text-[#25D366] mt-0.5" />
              <span>
                <span className="block text-[10px] font-mono uppercase tracking-wider text-white/40 leading-none mb-0.5">WhatsApp</span>
                <a
                  href={`https://wa.me/${BRAND.whatsappNumber}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-accent"
                >
                  {BRAND.whatsappFullDisplay}
                </a>
              </span>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="w-4 h-4 text-accent mt-0.5" />
              <a href={`mailto:${BRAND.emailSales}`} className="hover:text-accent break-all">{BRAND.emailSales}</a>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="w-4 h-4 text-accent mt-0.5" />
              <a href={`mailto:${BRAND.emailTeam}`} className="hover:text-accent break-all">{BRAND.emailTeam}</a>
            </li>
            <li className="flex items-start gap-3">
              <Clock className="w-4 h-4 text-accent mt-0.5" />
              <span className="font-mono text-xs leading-relaxed">{BRAND.hours}</span>
            </li>
          </ul>
        </div>

        <div>
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-accent">Oficinas</p>
          <p className="mt-5 text-white/75 text-sm leading-relaxed flex items-start gap-3">
            <MapPin className="w-4 h-4 text-accent mt-0.5 flex-shrink-0" />
            {BRAND.address}
          </p>
          <a
            href={BRAND.mapUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 mt-3 text-sm text-accent hover:underline"
            data-testid="footer-map-link"
          >
            <MapPin className="w-4 h-4" />
            Ver ubicación en Google Maps →
          </a>
          <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.25em] text-white/40">
            {BRAND.domain}
          </p>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="container-tight py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-white/50 font-mono text-xs">
          <p>© {new Date().getFullYear()} {BRAND.legal}. Todos los derechos reservados.</p>
          <p>Velarias Tens® · Arquitectura textil premium · Monterrey, MX</p>
        </div>
      </div>
    </footer>
  );
}
